// Copyright 2025. WebPros International GmbH. All rights reserved.

export const CLIENT_MENU = 'client-menu';
